import React, { useContext, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { FaSpinner } from 'react-icons/fa';
import { useNavigate, useParams } from 'react-router-dom';
// import businessLiteConfig from '../../../../BusinessLite.json';
import { observer } from 'mobx-react-lite';
import Logo from "../../../../assets/images/LogoNew.svg";
import { ApplicantHeaderActions, createApplicationFormUpdateHandler } from '../../../../components/ApplicationInvite';
import CountrySelectService from '../../../../components/CSC/CountrySelect/CountrySelectService';
import Stepper from '../../../../components/Common/Tab/Stepper';
import { FORM_AUTOFILL_PROPS } from '../../../../components/InputField/autofillProps';
import LogoutWithReason from '../../../../components/LogoutWithReason/LogoutWithReason';
import PayNow from '../../../../components/Payment/PayNow';
import useFormReviewShell from '../../../../hooks/useFormReviewShell';
import { DialogContext } from '../../../../store/context/DialogContext';
import { doGET, doPUT } from '../../../../util/HttpUtil';
import { rememberApplicationLoginPath } from '../../../../util/authResume';
import { handleUtmFormSubmit } from '../../../../util/utm';
import pincodeService from '../../components/PincodeField/PincodeService';
import { fetchBPlusData, STEP_NUM } from '../BPlushelper';
import { scrollToTop, STEPS } from '../IPlushelper';
import { SUBMIT_DOC_FLOW, validateSubmitDocuments } from '../submitDocumentValidation';

const getGotoUrl = ({ withDomain = false }) => {
    const urlParams = new URLSearchParams(window.location.search);
    const hash = window.location.hash ?? ""
    const urlWithoutHash = urlParams.get('goto') || '/business-plus/login';
    return withDomain ? window.location.origin + urlWithoutHash + hash : urlWithoutHash + hash;
}

const BplusCheckout = ({ asLabel, editMode = false, formId, refreshId }) => {
    const { edit_id, prime_id } = useParams();
    let { showError } = useContext(DialogContext);

    const [data, setData] = useState({
        entities: [{}],
        individuals: [{ isPrimaryUser: true, }],
    });

    const [applicationForm, setApplicationForm] = useState({});
    const [hasError, setHasError] = useState(false);
    const [editId, setEditID] = useState(edit_id ?? formId);
    const navigate = useNavigate();
    const [dataLoading, setDataLoading] = useState(false);
    const [validationkeyValue, setvalidationkeyValue] = useState({});
    const { reviewNavigation: businessPlusReviewNavigation } = useFormReviewShell({
        applicationId: editId,
        autoLoad: !asLabel && !editMode && Boolean(editId),
        fieldDefinitions: validationkeyValue,
        formData: data,
        currentWizard: "PAY_NOW",
        onPersistError: showError,
    });
    const { reviewNavigation: businessPrimeReviewNavigation } = useFormReviewShell({
        applicationId: prime_id,
        autoLoad: !asLabel && !editMode && Boolean(prime_id),
        fieldDefinitions: {},
        formData: null,
        currentWizard: "",
        onPersistError: showError,
    });

    useEffect(() => {
        if (formId) {
            setEditID(formId)
        }
    }, [formId])

    useEffect(() => {
        if (editId && (prime_id || data?.interestedInPrime)) {
            rememberApplicationLoginPath({
                applicationId: editId,
                loginPath: "/business-prime-plus/login",
            });
        }
    }, [data?.interestedInPrime, editId, prime_id]);

    const getValidationJSON = async () => {
        try {
            const response = await doGET("/api/cyclos/fields-json?group=Businesses_Lite");
            if (response.status === 200) {
                // const bJSON = businessLiteConfig;
                const bJSON = response?.data ?? {};
                const fieldsMap = bJSON?.fields.reduce((acc, field) => {
                    if (field?.field) {
                        acc[field.field] = field;
                    }
                    return acc;
                }, {});

                setvalidationkeyValue(fieldsMap)
            }
        } catch (error) {
            showError(error);
        }
    };

    useEffect(() => {
        getValidationJSON()
        CountrySelectService.fetchCyclosCountryMaster();
    }, []);

    const fetchDetail = async () => {
        let businessLiteResponse = {}

        setDataLoading(true)
        try {
            if (editId) {
                localStorage.setItem("formId", editId);
                if (Object.keys(pincodeService?.records)?.length === 0) {
                    pincodeService.fetch().catch(console.error);
                }
                businessLiteResponse = await fetchBPlusData(editId);
                const applicationResponse = await doGET(`/api/application-form/detail?id=${editId}&withExtension=true`)
                if (applicationResponse?.status == 200) {
                    setApplicationForm(applicationResponse?.data)
                    setData(businessLiteResponse)
                }
            }
        } catch (error) {
            console.log(error)
        } finally {
            setDataLoading(false)
            scrollToTop()
        }
    }

    useEffect(() => {
        fetchDetail();
    }, [editId, refreshId]);

    const handleUpdate = async ({
        skipUpdate,
        payload,
        isfetchDetail,
        isLastStep = false
    }) => {
        let errorFlag = false;

        setHasError(false);
        try {
            let submissionData = data;
            if (!asLabel && !skipUpdate) {
                const response = await doPUT(`/api/business-lite/update`, (payload ?? data))
                if (response?.status == 200) {
                    const nextData = {
                        ...(payload ?? data),
                        ...response?.data,
                    };
                    setData(prev => ({
                        ...prev,
                        ...response?.data,
                    }))
                    submissionData = nextData;
                } else {
                    errorFlag = true
                }
            }

            if (isLastStep && !asLabel) {
                if (errorFlag) {
                    return
                }
                const businessPlusApplicationResponse = await doGET(`/api/application-form/detail?id=${editId}&withExtension=true`)
                const isBusinessPlusApplicationOpen = businessPlusApplicationResponse?.data?.steps?.find(v => v?.label == STEPS.APPLICATION_FORM)?.status == 0
                if (businessPlusApplicationResponse?.status == 200) {
                    if (isBusinessPlusApplicationOpen) {
                        const businessPlusDocValidation = await validateSubmitDocuments({
                            flow: SUBMIT_DOC_FLOW.BUSINESS_PLUS_ONBOARDING,
                            recordId: editId,
                            data: submissionData,
                            applicationForm: businessPlusApplicationResponse?.data,
                        });

                        if (!businessPlusDocValidation?.isValid) {
                            setHasError(true);
                            showError(businessPlusDocValidation?.errors?.[0]?.error || "Please upload all required documents before submitting.");
                            return;
                        }

                        const submitResponse = await doGET(`/api/business-lite/submit?id=${editId}&markFormSubmit=true&markDocSubmit=true`)
                        try {
                            doGET(`/api/application-doc/cert/beneficial-owners?form_id=${editId}`)
                        } catch (error) {

                        }

                        if (submitResponse?.status == 200) {
                            await businessPlusReviewNavigation?.markVisibleTasksResponded?.({ quiet: true });
                            handleUtmFormSubmit({
                                formType: "BUSINESS_PLUS",
                                utmPayload: {
                                    utm_source: applicationForm?.extension?.utm_source,
                                    utm_medium: applicationForm?.extension?.utm_medium,
                                    utm_campaign: applicationForm?.extension?.utm_campaign,
                                    utm_content: applicationForm?.extension?.utm_content,
                                    utm_term: applicationForm?.extension?.utm_term,
                                }
                            });
                        } else {
                            errorFlag = true
                        }
                    }

                    if (!errorFlag && prime_id) {
                        const businessPrimeApplicationResponse = await doGET(`/api/application-form/detail?id=${prime_id}&withExtension=true`)
                        if (businessPrimeApplicationResponse?.status == 200 && businessPrimeApplicationResponse?.data?.steps?.find(v => v?.label == "Application Form")?.status == 0) {
                            try {
                                const businessPrimeDetailResponse = await doGET(`/api/business-prime/detail?id=${prime_id}`);
                                const businessPrimeDocValidation = await validateSubmitDocuments({
                                    flow: SUBMIT_DOC_FLOW.BUSINESS_PRIME_APPLICATION,
                                    recordId: prime_id,
                                    data: businessPrimeDetailResponse?.data ?? {},
                                    applicationForm: businessPrimeApplicationResponse?.data,
                                });

                                if (!businessPrimeDocValidation?.isValid) {
                                    setHasError(true);
                                    showError(businessPrimeDocValidation?.errors?.[0]?.error || "Please upload all required documents before submitting.");
                                    return;
                                }

                                const bPrimeSubmitResponse = await doGET(`/api/business-prime/submit?id=${prime_id}&markFormSubmit=true&markDocSubmit=true`)
                                if (bPrimeSubmitResponse?.status == 200) {
                                    await businessPrimeReviewNavigation?.markVisibleTasksResponded?.({ quiet: true });
                                    //     handleUtmFormSubmit({
                                    //         formType: "BUSINESS_PRIME", utmPayload: {
                                    //             utm_source: applicationForm?.extension?.utm_source,
                                    //             utm_medium: applicationForm?.extension?.utm_medium,
                                    //             utm_campaign: applicationForm?.extension?.utm_campaign,
                                    //             utm_content: applicationForm?.extension?.utm_content,
                                    //             utm_term: applicationForm?.extension?.utm_term,
                                    //         }
                                    //     });
                                } else {
                                    errorFlag = true;
                                }
                            } catch (error) {
                                errorFlag = true;
                            }
                        }
                    }
       
                    await new Promise(resolve => setTimeout(resolve, 1000));
                    if (isfetchDetail) {
                        await fetchDetail();
                    }
                }

            } else {
                if (isfetchDetail) fetchDetail()
                scrollToTop()
            }
        } catch (error) {
            setHasError(true);
            showError(error)
            errorFlag = true
        }


        return errorFlag ? { status: 400 } : { status: 200 }

    };

    const isLoading = dataLoading || !Object.keys(validationkeyValue)?.length || !CountrySelectService?.cyclosCountryMaster?.length;

    return (
        <div className={!asLabel && !editMode ? 'form-content-container xl' : ""}>
            <div className='form-content-header'>
                {(!asLabel && !editMode) && <img
                    src={Logo}
                    alt={("fv-bank")}
                    className="logo logo-dark form-content-logo"
                />}

                <ApplicantHeaderActions
                    applicationForm={applicationForm}
                    formData={data}
                    formId={editId}
                    formType={applicationForm?.formType}
                    onApplicationFormUpdated={createApplicationFormUpdateHandler(setApplicationForm)}
                    disabled={asLabel || editMode}
                    logoutComponent={<LogoutWithReason form_id={data?._id} />}
                />

            </div>
            {isLoading ?
                <div className=" form-content-body  d-flex justify-content-center align-items-center flex-1">
                    <FaSpinner size={20} className="spinner" />
                </div> :
                <Form className={asLabel || editMode ? "" : 'form-content-body '} noValidate {...FORM_AUTOFILL_PROPS}>
                    {(!asLabel && !editMode) && <div className='form-content-body-header'>
                        <div className="heading">{(data?.interestedInPrime || prime_id)? ("Business Prime Account Application") : ("Business Plus Account Application")}</div>
                    </div>}

                    <div className='form-content-body-content'>
                        <Stepper
                            variant='dark'
                            activeTab={STEP_NUM.PAY_NOW}
                            asLabel={asLabel || editMode}
                            onChange={(s) => { }}
                        >
                            <div num={STEP_NUM.INTRODUCTION} label={("Introduction and Account Features")}></div>
                            <div num={STEP_NUM.BUSINESS_DETAILS} label={"Business Information"}> </div>
                            <div num={STEP_NUM.BUSINESS_ACTIVITY} label={"Business Activities and Account Usage"}> </div>
                            <div num={STEP_NUM.BUSINESS_COMPLIANCE} label={"Business Compliance and Licensing"}></div>
                            <div num={STEP_NUM.DOCUMENTS} label={"Document Upload Center"}></div>
                            <div num={STEP_NUM.SELF_DECLARATION} label={"Signature"}> </div>
                            <div num={STEP_NUM.REFERRAL_AND_SOURCE} label={"Referral and Source Information"}> </div>

                            {!asLabel && <div num={STEP_NUM.PAY_NOW} label={("Pay Now")}>
                                <PayNow
                                    data={{ ...data, formType: "BUSINESS_PLUS" }}
                                    handleUpdateFormData={async (payload) => {
                                        const response = await handleUpdate({ payload });
                                        return response;
                                    }}
                                    setHasError={setHasError}
                                    onBackClick={() => {
                                        const redirectUrl = getGotoUrl({ withDomain: false });
                                        navigate(redirectUrl, { replace: true });
                                    }}
                                    onSubmit={async () => {
                                        const response = await handleUpdate({
                                            isfetchDetail: true,
                                            isLastStep: true,
                                            skipUpdate: true
                                        });
                                        if (response?.status == 200) {
                                            if (prime_id) {
                                                navigate(`/business-prime/${prime_id}`, { replace: true });
                                            } else {
                                                navigate(`/business-plus/${edit_id}`, { replace: true });
                                            }
                                        }
                                    }}
                                />
                            </div>}

                        </Stepper>
                    </div>
                </Form>
            }
        </div>
    );
}

export default observer(BplusCheckout);
